import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import './plugins/element.js'
import '@/style/index.css'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import './permission.js'
import '@/icons/index' // icon
import selecturl from '@/components/selecturl/index'
import ContextMenu from '@/plugins/ContextMenu'
import '@/utils/flexible'

Vue.use(Vueaxios, axios)
Vue.config.productionTip = false

// eslint-disable-next-line no-extend-native
Date.prototype.format = function(fmt = 'yyyy-MM-dd HH:mm:ss') {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, // 小时
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  var week = {
    '0': '日',
    '1': '一',
    '2': '二',
    '3': '三',
    '4': '四',
    '5': '五',
    '6': '六'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '星期' : '周') : '') + week[this.getDay() + ''])
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
Vue.use(selecturl)
Vue.prototype.$selecturl = selecturl
Vue.use(ContextMenu)
window.$vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
